export default {"src":"/_next/static/media/radio-active.24c8b903.svg","height":16,"width":16};